var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "gg-card",
        {
          staticClass: "mt-6"
        },
        [
          _c(
            "gg-card-text",
            {
              staticClass: "px-4 py-10"
            },
            [
              _vm.loading || _vm.error || _vm.deployError
                ? _c(
                    "v-row",
                    [
                      _vm.loading
                        ? _c(
                            "v-col",
                            {
                              staticClass: "text-center",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "h2",
                                {
                                  staticClass: "text--black"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.finalText.loading_title) +
                                      " "
                                  )
                                ]
                              ),
                              _c("v-progress-circular", {
                                staticClass: "my-7",
                                attrs: {
                                  indeterminate: "",
                                  width: "2",
                                  size: "64",
                                  color: "primary"
                                }
                              }),
                              _c("p", [
                                _vm._v(
                                  " " + _vm._s(_vm.finalText.loading_text) + " "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.error
                        ? _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "text-center"
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass: "text--black"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.finalText.error_title
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "red",
                                            size: "180"
                                          }
                                        },
                                        [_vm._v(" mdi-close-circle ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.finalText.error_text) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "gg-btn",
                                        {
                                          on: {
                                            click: function click($event) {
                                              return _vm.setStep(2)
                                            }
                                          }
                                        },
                                        [_vm._v(" Back ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.deployError
                        ? _c(
                            "v-col",
                            {
                              staticClass: "text-center",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass: "text--black"
                                        },
                                        [_vm._v(" Warning: Content Exists ")]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "red",
                                            size: "180"
                                          }
                                        },
                                        [_vm._v(" mdi-close-circle ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Content currently exists on your domain " +
                                          _vm._s(_vm.second_step.domains[0]) +
                                          ". Would you like to overwrite the existing content? "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass:
                                          "d-inline-flex text-center",
                                        attrs: {
                                          label:
                                            "I understand that this step is irreversible. Go ahead and overwrite the existing content."
                                        },
                                        model: {
                                          value: _vm.overwriteApplication,
                                          callback: function callback($$v) {
                                            _vm.overwriteApplication = $$v
                                          },
                                          expression: "overwriteApplication"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "gg-btn",
                                        {
                                          on: {
                                            click: function click($event) {
                                              return _vm.setStep(2)
                                            }
                                          }
                                        },
                                        [_vm._v(" Go Back ")]
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mx-1",
                                          attrs: {
                                            disabled: !_vm.overwriteApplication,
                                            color: "primary"
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.submit()
                                            }
                                          }
                                        },
                                        [_vm._v(" Continue ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "v-row",
                    {
                      staticClass: "text-center"
                    },
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass: "text--black"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.finalText.success_title) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        size: "180"
                                      }
                                    },
                                    [_vm._v(" mdi-checkbox-marked-circle ")]
                                  )
                                ],
                                1
                              ),
                              _c("v-col", {
                                attrs: {
                                  cols: "12"
                                },
                                domProps: {
                                  innerHTML: _vm._s(_vm.finalText.success_text)
                                }
                              }),
                              _vm.application.flow === "wordpress"
                                ? _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold"
                                        },
                                        [_vm._v("Email: ")]
                                      ),
                                      _vm._v(_vm._s(_vm.email) + " "),
                                      _c("br"),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold"
                                        },
                                        [_vm._v("Password: ")]
                                      ),
                                      _vm._v(_vm._s(_vm.password) + " "),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            top: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref) {
                                                  var on = _ref.on,
                                                    attrs = _ref.attrs
                                                  return [
                                                    _c(
                                                      "gg-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              icon: "",
                                                              color: "primary",
                                                              "x-small": ""
                                                            },
                                                            on: {
                                                              click: function click(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                $event.preventDefault()
                                                                return _vm.copyPassword(
                                                                  $event
                                                                )
                                                              }
                                                            }
                                                          },
                                                          "gg-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            "mdi-clipboard-text"
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2283521288
                                          )
                                        },
                                        [_c("span", [_vm._v("Copy Password")])]
                                      ),
                                      _c("input", {
                                        attrs: {
                                          type: "hidden",
                                          id: "app-password"
                                        },
                                        domProps: {
                                          value: _vm.password
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _vm.path === "New Website"
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                tile: ""
                                              },
                                              on: {
                                                click: _vm.manageService
                                              }
                                            },
                                            [_vm._v("Manage Account")]
                                          ),
                                          _c(
                                            "gg-btn",
                                            {
                                              staticClass: "mx-1",
                                              attrs: {
                                                color: "primary",
                                                tile: ""
                                              },
                                              on: {
                                                click: _vm.openLink
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.finalText.btn_text
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.path === "Migration" ||
                                  _vm.path === "Starter Site"
                                    ? _c(
                                        "gg-btn",
                                        {
                                          attrs: {
                                            tile: "",
                                            color: "primary",
                                            to: {
                                              name: "ticket_view",
                                              params: {
                                                ticketid: this.ticket_id
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.finalText.btn_text) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }